import $ from 'jquery';
import anime from 'animejs';
const recreateVideoHeader = () => {
    if (document.querySelector('.header') && document.querySelector('.header').querySelector('.media video')) {
        let header = document.querySelector('.header');
        let vid = header.querySelector('.media video');

        let wrapper = header;
        let canvas = header.querySelector('.media canvas');
        let ctx = canvas.getContext('2d');

        let ratio = window.devicePixelRatio || 1;
        let vidWidth;
        let vidHeight;

        vid.addEventListener('loadedmetadata', function (e) {
            // console.log('onloadedmetadata');
            vid.style.transform = `scale(${ratio})`;

            vidWidth = vid.videoWidth;
            vidHeight = vid.videoHeight;

            canvas.width = vid.offsetWidth * ratio;
            canvas.height = vid.offsetHeight * ratio;

            canvas.style.width = vid.offsetWidth + "px";
            canvas.style.height = vid.offsetHeight + "px";

            drawingLoop();

            //resize scale for comparison
            vid.style.transform = `scale(1)`;
        });

        vid.addEventListener('loadeddata', function (e) {
            // console.log('onloadeddata');
            // setVideoBgColor(vid, wrapper);
            vid.play();
        });

        function drawingLoop() {
            requestId = window.requestAnimationFrame(drawingLoop)

            ctx.drawImage(vid, 0, 0, vidWidth, vidHeight, // source rectangle
                0, 0, canvas.width, canvas.height); // destination rectangle);
        }

        function setVideoBgColor(vid, backgroundElement) {
            // draw first four pixel of video to a canvas
            // then get pixel color from that canvas
            let canvas = document.createElement("canvas");
            canvas.width = 8;
            canvas.height = 8;

            let ctx = canvas.getContext("2d");
            ctx.drawImage(vid, 0, 0, 8, 8);

            let p = ctx.getImageData(0, 0, 8, 8).data;
            //dont take the first but fourth pixel [r g b]
            backgroundElement.style.backgroundColor = "rgb(" + p[60] + "," + p[61] + "," + p[62] + ")";
        }

        window.onresize = function (event) {
            //resize scale for comparison
            vid.style.transform = `scale(${ratio})`;

            vidWidth = vid.videoWidth;
            vidHeight = vid.videoHeight;

            canvas.width = vid.offsetWidth * ratio;
            canvas.height = vid.offsetHeight * ratio;

            canvas.style.width = vid.offsetWidth + "px";
            canvas.style.height = vid.offsetHeight + "px";

            //redraw canvas after resize
            ctx.drawImage(vid, 0, 0, vidWidth, vidHeight, // source rectangle
                0, 0, canvas.width, canvas.height); // destination rectangle);

            //resize scale for comparison
            vid.style.transform = `scale(1)`;
        };


        //add src
        vid.src = vid.getAttribute('data-src');
        vid.play();
    }
    if (document.querySelector('.wysiwyg_media') && document.querySelector('.wysiwyg_media').querySelector('.media video')) {
        const medias = document.querySelectorAll('.wysiwyg_media')

        medias.forEach(media => {
            let vid = media.querySelector('.media video');
            let canvas = media.querySelector('.media canvas');
            let ctx = canvas.getContext('2d');
            let ratio = window.devicePixelRatio || 1;
            let vidWidth;
            let vidHeight;

            vid.addEventListener('loadedmetadata', function (e) {
                // console.log('onloadedmetadata');
                vid.style.transform = `scale(${ratio})`;

                vidWidth = vid.videoWidth;
                vidHeight = vid.videoHeight;

                canvas.width = vid.offsetWidth * ratio;
                canvas.height = vid.offsetHeight * ratio;

                canvas.style.width = vid.offsetWidth + "px";
                canvas.style.height = vid.offsetHeight + "px";

                drawingLoop();

                //resize scale for comparison
                vid.style.transform = `scale(1)`;
            });

            vid.addEventListener('loadeddata', function (e) {
                // console.log('onloadeddata');
                // setVideoBgColor(vid, wrapper);
                vid.play();
            });

            function drawingLoop() {
                requestId = window.requestAnimationFrame(drawingLoop)

                ctx.drawImage(vid, 0, 0, vidWidth, vidHeight, // source rectangle
                    0, 0, canvas.width, canvas.height); // destination rectangle);
            }

            function setVideoBgColor(vid, backgroundElement) {
                // draw first four pixel of video to a canvas
                // then get pixel color from that canvas
                let canvas = document.createElement("canvas");
                canvas.width = 8;
                canvas.height = 8;

                let ctx = canvas.getContext("2d");
                ctx.drawImage(vid, 0, 0, 8, 8);

                let p = ctx.getImageData(0, 0, 8, 8).data;
                //dont take the first but fourth pixel [r g b]
                backgroundElement.style.backgroundColor = "rgb(" + p[60] + "," + p[61] + "," + p[62] + ")";
            }

            window.onresize = function (event) {
                //resize scale for comparison
                vid.style.transform = `scale(${ratio})`;

                vidWidth = vid.videoWidth;
                vidHeight = vid.videoHeight;

                canvas.width = vid.offsetWidth * ratio;
                canvas.height = vid.offsetHeight * ratio;

                canvas.style.width = vid.offsetWidth + "px";
                canvas.style.height = vid.offsetHeight + "px";

                //redraw canvas after resize
                ctx.drawImage(vid, 0, 0, vidWidth, vidHeight, // source rectangle
                    0, 0, canvas.width, canvas.height); // destination rectangle);

                //resize scale for comparison
                vid.style.transform = `scale(1)`;
            };
            //add src
            vid.src = vid.getAttribute('data-src');
            vid.play();
        })
    }
};


export { recreateVideoHeader };
